import CopyButton from "@/modules/common/components/ui/copy-button";
import UpdateStatusDropdown from "@/modules/property-tracks/components/desktop/property-stage/update-status";
import TrackUserAgent from "@/modules/property-tracks/components/linked-tracks-tab/track-card/track-user";
import { Track } from "@/modules/property-tracks/types";
import {
  Box,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";

function PropertyStatusMobile({ track }: Readonly<{ track: Track }>) {
  const theme = useTheme();

  return (
    <Box
      sx={(t) => ({
        border: `1px solid ${t.nawy.colors.semantic.border.secondary}`,
        backgroundColor: "white",
        borderRadius: t.nawy.radius.xl,
        gap: t.nawy.spacing.xxs,
      })}
    >
      {/* Header: title + Track ID inline */}
      <Box
        sx={(t) => ({
          px: t.nawy.spacing.md,
          pt: t.nawy.spacing.xs,
          pb: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        })}
      >
        <Typography
          variant="inherit"
          sx={{ fontSize: "15px", fontWeight: 600, lineHeight: "22px" }}
        >
          Property Status
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={(t) => ({
              ...t.nawy.typography.english.variants.body.sm.regular,
              color: t.nawy.colors.semantic.text.secondary,
            })}
          >
            Track ID
          </Typography>
          <CopyButton
            text={track?.uid ?? ""}
            size={14}
            color={theme.nawy.colors.semantic.layer.accent}
          />
        </Box>
      </Box>

      <Stack
        sx={(t) => ({
          px: t.nawy.spacing.md,
          pt: "4px",
          pb: t.nawy.spacing.xs,
          gap: t.nawy.spacing.xs,
        })}
      >
        {/* One-row split: status pill + assigned agent */}
        <Stack direction="row" gap={1} alignItems="stretch">
          <Tooltip title={track?.status?.name ?? ""} placement="top" arrow>
            <Box
              sx={(t) => ({
                flex: 1,
                minWidth: 0,
                display: "flex",
                "& > *": { width: "100%" },
                "& .MuiOutlinedInput-root": {
                  borderRadius: `${t.nawy.radius.lg} !important`,
                  "& fieldset": {
                    borderColor: `${t.nawy.colors.semantic.border.primary} !important`,
                  },
                },
              })}
            >
              <UpdateStatusDropdown
                trackStageId={track?.trackStage?.id}
                defaultStatus={track?.status}
                trackUId={track?.uid}
                trackTypeId={track?.trackType.id}
              />
            </Box>
          </Tooltip>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <TrackUserAgent track={track} editable />
          </Box>
        </Stack>

      </Stack>
    </Box>
  );
}

export default PropertyStatusMobile;
